import * as React from "react";
import styled from "styled-components";
import Button from "@8x8/oxygen-button";
import { ListIcon } from "@8x8/oxygen-icon";
import { useClickOutside } from "@8x8/oxygen-utils";

import ColumnTreeView from "./ColumnTreeView";
import { COLORS } from "@/react/theme/constants";

const TreeContainer = styled.div`
  position: absolute;
  top: 48px;
  left: 4px;
  width: 400px;
  height: 540px;
  z-index: 10;
  background: ${COLORS.background};
  border-radius: 8px;
  box-shadow: ${COLORS.primary} 0 1px 4px;
  overflow-y: scroll;
  visibility: ${(props) => (props?.isExpanded === true ? "unset" : "hidden")};
`;

/**
 * Hides {@link ColumnTreeView} in a "drop-down menu" so
 * it does not always cloud the UI.
 */
const ColumnSelector = ({ setColumnVisibility, setActiveGroups }) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  // Close the menu on outside clicks.
  const divRef = useClickOutside((event) => {
    if (isExpanded) {
      setIsExpanded(false);
    }
  });

  return (
    <div ref={divRef}>
      <Button
        buttonText="Manage Columns"
        aria-controls="column-controls"
        id="column-controls"
        isActive={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <ListIcon invertColors />
        Manage Columns
      </Button>
      <TreeContainer isExpanded={isExpanded}>
        <ColumnTreeView
          setColumnVisibility={setColumnVisibility}
          setActiveGroups={setActiveGroups}
        />
      </TreeContainer>
    </div>
  );
};

export default ColumnSelector;
